import BaseServiceHttp from '../baseService'
class Emprestimos extends BaseServiceHttp {
  constructor(id) {
    const resource = 'emprestimos'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Emprestimos(id)
